/* UNIK · Quick Friday — qf-sizeguide.js (2025-10-28)*/
(function(){
  if (window.__QF_SIZEGUIDE_INITIALIZED__) return;
  window.__QF_SIZEGUIDE_INITIALIZED__ = true;

  var lastTrigger = null;

  function lockScroll(lock){
    var cls = 'qf-scroll-locked';
    var root = document.documentElement;
    var body = document.body;
    if (!root || !body) return;
    if (lock){
      root.classList.add(cls);
      body.classList.add(cls);
    } else {
      root.classList.remove(cls);
      body.classList.remove(cls);
    }
  }

  // Inject a single <style> for scroll lock if not present
  (function ensureScrollLockStyle(){
    var styleId = 'qf-scroll-lock-style';
    if (!document.getElementById(styleId)){
      var st = document.createElement('style');
      st.id = styleId;
      st.textContent = 'html.qf-scroll-locked, body.qf-scroll-locked{overflow:hidden !important;}';
      document.head.appendChild(st);
    }
  })();

  function trapFocus(dlg){
    if (!dlg) return;
    // collect focusables
    var focusable = dlg.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    focusable = Array.prototype.filter.call(focusable, function(el){
      return !el.hasAttribute('disabled') && el.tabIndex !== -1 && el.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    function onKey(e){
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first){
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last){
        e.preventDefault(); first.focus();
      }
    }
    dlg.addEventListener('keydown', onKey);
    dlg.__qf_untrap__ = function(){ dlg.removeEventListener('keydown', onKey); };
  }

  function openDialogById(id, triggerEl){
    var dlg = document.getElementById(id);
    if (!dlg || typeof dlg.showModal !== 'function') return;
    lastTrigger = triggerEl || null;
    dlg.showModal();
    lockScroll(true);
    // focus
    setTimeout(function(){
      var target = dlg.querySelector('[autofocus], .qf-sizeguide__close, button, [href], [tabindex]:not([tabindex="-1"])');
      (target || dlg).focus();
      trapFocus(dlg);
    }, 0);
  }

  function closeDialog(dlg){
    if (!dlg) return;
    try { dlg.close(); } catch(_){}
  }

  // Single delegated click handler (open/close)
  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-sizeguide-open]');
    if (openBtn){
      openDialogById(openBtn.getAttribute('data-sizeguide-open'), openBtn);
      return;
    }
    if (e.target.closest('[data-sizeguide-close]')){
      closeDialog(e.target.closest('dialog'));
      return;
    }
  });

  // Backdrop click: close when clicking outside .qf-sizeguide__inner
  document.addEventListener('mousedown', function(e){
    var dlg = e.target.closest('dialog');
    if (!dlg || !dlg.open) return;
    var inner = dlg.querySelector('.qf-sizeguide__inner');
    if (!inner) return;
    if (!inner.contains(e.target)) closeDialog(dlg);
  });

  // Esc to close currently open dialog
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      var openDlg = document.querySelector('dialog[open]');
      if (openDlg) closeDialog(openDlg);
    }
  });

  // On any dialog close: release focus trap & scroll-lock, restore focus to trigger
  document.addEventListener('close', function(e){
    var dlg = e.target;
    if (!dlg || !dlg.tagName || dlg.tagName.toLowerCase() !== 'dialog') return;
    if (dlg.__qf_untrap__) { try{ dlg.__qf_untrap__(); }catch(_){} }
    lockScroll(false);
    if (lastTrigger) { try{ lastTrigger.focus(); }catch(_){} }
  }, true);

  // Shopify Editor compatibility (delegation already covers load/unload,
  // but we also refresh "hiding guards" on each load for safety)
  function applyVisibilityGuards(){
    var wrappers = document.querySelectorAll('.qf-sizeguide, .qf-size-guide');
    wrappers.forEach(function(w){
      var hasBtn = !!w.querySelector('.qf-sizeguide__btn');
      if (!hasBtn){
        w.style.display = 'none';
        w.setAttribute('aria-hidden','true');
      } else {
        // reset if previously hidden
        w.style.removeProperty('display');
        w.removeAttribute('aria-hidden');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', applyVisibilityGuards);
  document.addEventListener('shopify:section:load', applyVisibilityGuards);
  document.addEventListener('shopify:section:unload', applyVisibilityGuards);
})();
